export default "__VITE_ASSET__1fef1a2d__"